import { createAPIDefinition as InternalAPIRequestGlobalConfig } from './apiCreateDefinition';
export class APIFactory {
    constructor(apiGlobalConfig) {
        this.apiGlobalConfig = undefined;
        this.apiGlobalConfig = apiGlobalConfig;
        this.createAPIDefinition = this.createAPIDefinition.bind(this);
    }
    updateConfig(apiGlobalConfig) {
        this.apiGlobalConfig = Object.assign(Object.assign({}, this.apiGlobalConfig), apiGlobalConfig);
    }
    createAPIDefinition(...args) {
        const requestConfig = args[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return InternalAPIRequestGlobalConfig(requestConfig, () => this.apiGlobalConfig);
    }
}
